import React from 'react';

const HeroBanner = () => {
    return (
        <div className="hero">
            <div className="hero_container">
                <div className="hero__inner">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="hero__title">
                                <span className="hero_title_highlight">Allstate Group Health</span>
                                {' '}
                                <span>provider directory</span>
                            </div>
                            <div className="hero__sub-title">
                                Locate participating providers, facilities, and pharmacies.
                            </div>
                        </div>
                    </div>
                    <div className="hero__img" />
                </div>
            </div>
        </div>
    );
};
export default HeroBanner;
